module.exports = "//public.getcloudapp.com/packs/media/images/upload-copy@2x-b5d57f22de2f489e1d85c7efc0ccb627.png";